export default {
  bind(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const animation = el.animate(
          [
            { opacity: 0, transform: "translateY(20px)" }, // 初始状态
            { opacity: 1, transform: "translateY(0)" }, // 结束状态
          ],
          {
            duration: 1000,
            easing: "ease-in",
            fill: "forwards",
          }
        );
        animation.pause();
        if (entry.isIntersecting) {
          animation.play();
          observer.unobserve(el);
        } else {
          animation.cancel();
        }
      });
    });

    el._observer = observer;
    observer.observe(el);
  },
  unbind(el) {
    if (el._observer) {
      el._observer.unobserve(el);
      el._observer.disconnect();
      delete el._observer;
    }
  },
};
